import PropTypes from "prop-types";
import React, { Fragment, useEffect, useMemo, useState } from "react";
import MetaTags from "react-meta-tags";
import LayoutOne from "../../layouts/LayoutOne";
import { useToasts } from "react-toast-notifications";
import { Controller, useForm } from "react-hook-form";
import { Button, Divider, FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import axios from "axios";
import { connect } from "react-redux";
import HeroSliderOneNew from "./HeroSliderOneNew";
import ReactLoading from "react-loading";
import BannerModel from "./BannerModel";
import TipoBanner from "./TipoBanner";
import PersonalizeBannersSidebarContent from "./PersonalizzaBannersSidebarContent";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import _ from "lodash";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import HomeBanner from "../../pages/home/HomeBanner";

const bannerSchema = yup.object({
  bannerType: yup.string().required("Devi inserire il tipo di banner"),
  bannerName: yup.string().required("Devi inserire un nome per il banner"),
});

const PersonalizeBanners = (props) => {
  //const endPointBaseUrl = global.endpoint; 
  //const endPointBaseUrlImage = global.endpoint; 
  const endPointBaseUrl = global.endpoint;// "http://localhost:8180/api/"; // global.endpoint;   https://dgaapi.pegasogest.it/api/
  const endPointBaseUrlImage = 'https://pegaso3cloudapi.pegasogest.it/api/'; //global.endpoint; //'https://pegaso3cloudapi.pegasogest.it/api/'; //global.endpoint;

  const { userData } = props;
  const defaultValues = BannerModel();
  const tipoBanner = TipoBanner();

  const routeParams = useParams();
  const [timeStampForm, setTimeStampForm] = useState(routeParams.timeStamp);

  //const bannerNow = window['bannerHome']

  const methods = useForm({
    mode: 'onChange',
    defaultValues,
    //resolver: bannerSchema
    resolver: yupResolver(bannerSchema),
  });

  const { formState, reset, watch, setValue, getValues, trigger, control } = methods;
  const { isValid, dirtyFields, errors } = formState;
  const form = watch();

  const { addToast } = useToasts();

  const [allBanners, setAllBanners] = useState([]);
  const [immagineClick, setImmagineClick] = useState({ tipo: 'immagineGrande', index: -1 })
  const [inSalvataggio, setInSalvataggio] = useState(false);
  const [noRouteNavigate, setNoRouteNavigate] = useState(false);

  const history = useHistory();

  const updateFormBanner = (timeStamp) => {

    let currentBanner;

    if (!timeStamp) {
      currentBanner = { ...defaultValues }
    } else {
      currentBanner = allBanners.find(_banner => _banner.timeStamp === timeStamp) || defaultValues;
    }
    reset(currentBanner);

  }

  useEffect(() => {
    getBanners(routeParams.timeStamp);
  }, [routeParams?.timeStamp]);

  useEffect(() => {
    const tsRoute = routeParams.timeStamp || '';
    const tsForm = form.timeStamp || '';

    if (tsRoute != tsForm && allBanners.length > 0) {
      // setTimeout(() => {

      setTimeStampForm(tsRoute);
      updateFormBanner(tsRoute);
      // }, 100);
    }
  }, [allBanners]);

  const cambiaImmagineClick = (_values) => {
    if (inSalvataggio) return;
    setImmagineClick(_values);
  }

  const handleSubmit = async e => {
    //
  }

  function VerificaCampiObbligatori() {
    //
  }

  const getBanners = () => {

    const endPoint = endPointBaseUrl + 'siteadmin/getAllHomeBanners';
    //console.log(endPoint);
    new Promise((resolve, reject) => {
      axios.post(endPoint, { giveBanner: true }).then(response => {
        if (!response.data.errore) {
          resolve(response.data);
          const data = response.data?.data;
          //console.log(data);
          const parsedData = data.map(_banner => ({ ..._banner, bannerImageScroll: JSON.parse(_banner.bannerImageScroll || []) }));
          setAllBanners(parsedData);
        } else {
          reject(response.data.errorDescription);
        }
      });
    });
  }


  const setBanners = async (_default, newBanners, _noRoute) => {
    const endPoint = endPointBaseUrl + 'siteadmin/saveHomeBanner';
    const bannerToSend = _default || { ...form, timeStamp: form.timeStamp || Date.now() + '' };

    //console.log(userData);
    const returnValue = await new Promise((resolve, reject) => {
      axios.post(endPoint, { data: { record: bannerToSend } }).then(response => {
        if (!response.data.errore) {
          //console.log(userData);
          resolve(response.data);
          const data = response.data?.data;
          //console.log(data);

          const _timeStamp = bannerToSend.timeStamp;
          const savedBanner = { ...form, ...data, timeStamp: _timeStamp };
          const _allBanners = [...allBanners.filter(_banner => _banner.timeStamp !== savedBanner.timeStamp), ...[savedBanner]];


          if (_noRoute || noRouteNavigate) {
            setNoRouteNavigate(newBanners || _allBanners);
            setAllBanners(newBanners || _allBanners);
            reset(savedBanner);
            setInSalvataggio(false);
            return;
          }

          setAllBanners(newBanners || _allBanners);
          reset(savedBanner);
          setInSalvataggio(false);

          if (savedBanner.timeStamp != routeParams.timeStamp && allBanners.length > 0) {
            navigateTO('/personalizzaBanners/' + savedBanner.timeStamp);
          }
          setNoRouteNavigate(false);
        } else {
          reject(response.data.errorDescription);
          addToast(response.data.errorDescription);
          setInSalvataggio(false);
          return ({ errore: true })
        }
      });
    });

    return returnValue;
  }


  const uploadNew = async (file) => {
    const endPoint = `${endPointBaseUrlImage}pegasoCloud/api/upload`;
    const risultato = await axios.post(endPoint, { file }).then(response => response.data).catch(error => error);
    return risultato;
  }


  const submitImage = async (e) => {
    const elementName = immagineClick?.tipo || 'immagineGrande';
    //const imageIndex = immagineClick?.index < 0 ? form.bannerImageScroll.length : immagineClick.index;

    if (document.getElementById(elementName)) document.getElementById(elementName).src = URL.createObjectURL(e.target.files?.[0])
    var nameFile = e.target?.files?.[0]?.name
    if (!nameFile) return

    const newA = (immagineClick?.index === undefined || immagineClick?.index === -1) ? { ...defaultValues.bannerImageScrollNew } : { ...form.bannerImageScroll[immagineClick?.index] };
    setInSalvataggio(true);

    fileToBase64(e.target?.files?.[0]).then(
      async data => {
        newA.imageX = data;
        newA.nameFile = nameFile;
        newA.id = nameFile;
        newA.timeStamp = Date.now() + '';
        newA.url = 'https://www.npmjs.com/package/react-mui-dropzone?activeTab=readme';
        const body = {};
        body.file = data.split(",")[1];
        body.name = Date.now() + "." + nameFile.split(".")[1];
        body.isFolder = false;
        body.caricaSuDatabase = false;

        const uploadedFile = await uploadNew(body);
        if (uploadedFile.esito === 'OK') newA.imageX = uploadedFile.linkFile;
        else addToast('upload del file non riuscito', { appearance: "error", autoDismiss: true, placement: 'bottom-left' });

        if (elementName === 'immaginePiccola') newA.headImage = newA.imageX;
        else newA.image = newA.imageX;

        if (immagineClick?.index === undefined || immagineClick?.index === -1) {
          const nuovo = [...form.bannerImageScroll || [], newA];
          setValue('bannerImageScroll', nuovo);
          dirtyFields.bannerImageScroll = nuovo;
          setHeroSliderData(nuovo);
          changebannerImageScroll(immagineClick?.index < 0 ? form.bannerImageScroll.length : immagineClick.index, nuovo);
          setInSalvataggio(false);
        }
        else {
          changebannerImageScroll(immagineClick?.index, { ...form.bannerImageScroll[immagineClick.index], ...newA });
          setInSalvataggio(false);
        }

      }
    )
  }

  useEffect(() => {
    photoOnClick();
  }, [immagineClick])

  const photoOnClick = () => {
    if (!isValid) {
      if (form?.bannerType != 0) addToast('Inserisci il nome del banner', { appearance: "info", autoDismiss: true, placement: 'bottom-left' })
      trigger();
      return;
    }
    const _element = document.getElementById("image-upload");
    if (!_element) return;
    _element.click();
  }

  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = (e) => reject(e)
    })

  const deletebannerImageScroll = (jSonToTrash) => {
    if (!form.bannerImageScroll || form.bannerImageScroll.length === 0) return;
    const newValues = form.bannerImageScroll.filter(_element => _element.timeStamp != jSonToTrash.timeStamp);
    setValue('bannerImageScroll', newValues)
    setHeroSliderData(newValues);
    dirtyFields.bannerImageScroll = newValues;
  }

  const changebannerImageScroll = (index, newJValue) => {
    const array = [... (form.bannerImageScroll || [])];

    let firstValues = [];
    let lastValues = [];

    for (let _index = 0; _index < index; _index++) {
      firstValues[_index] = array[_index];
    }

    for (let _index = index + 1; _index < array.length; _index++) {
      lastValues[_index - index - 1] = array[_index];
    }

    const newValues = (index < 0 || index >= array.length) ? [...newJValue] : [...firstValues, newJValue, ...lastValues];

    setValue('bannerImageScroll', newValues);
    setHeroSliderData(newValues);
    dirtyFields.bannerImageScroll = newValues;
  }


  const setHeroSliderData = (_bannerImageScroll) => {
    if (!_bannerImageScroll || _bannerImageScroll.length < 1) {
      const _newValue = [];
      setValue('heroSliderData', _newValue);
      return _newValue;
    }

    const _new = _bannerImageScroll.map((_element, index) => {
      return { id: index + 1, ..._element };
    });


    setValue('heroSliderData', _new);
    return _new;
  }

  const getBanner = () => {
    //console.log('insalvataggio ' + inSalvataggio + ' ' + form.bannerType)
    if (inSalvataggio) return null;

    switch (form.bannerType) {
      case 1:
        return (<HeroSliderOneNew heroSliderData={form.bannerImageScroll} forTestOnly={true} />);
      default:
        return null;
    }
  }

  const getBannerList = () => {
    if (!form.bannerImageScroll || form.bannerImageScroll.length === 0) return null;
    switch (form.bannerType) {
      case 1:
        return getBannerList1();
      case 2:
        return getBannerList2();
      default:
        return null;
    }
  }

  const getBannerList1 = () => {
    if (!form.bannerImageScroll || form.bannerImageScroll.length === 0) return null;

    return (
      form.bannerImageScroll?.map((item, i) => {
        return (
          <div style={{ backgroundColor: '#f3f3f3', paddingBottom: '5px', paddingBottom: '5px', marginBottom: '5px' }} >

            <div className="row">

              <div className="col-lg-1">
                <img id={"immagineGrande" + i}
                  style={{ height: 75, width: null, padding: 2, margin: 2, cursor: "pointer", }}
                  src={item?.image ?
                    item.image :
                    "https://t3.ftcdn.net/jpg/03/46/83/96/360_F_346839683_6nAPzbhpSkIpb8pmAwufkC7c5eD7wYws.jpg"}
                  //onClick={() => photoOnClick()} 
                  onClick={() => cambiaImmagineClick({ tipo: 'immagineGrande', index: i, clicked: !immagineClick.clicked })}

                  title="Clicca per cambiare l'immagine"></img>
              </div>

              <div className="col-lg-1">
                <img id={"immaginePiccola" + i}
                  style={{ height: 75, width: null, padding: 2, cursor: "pointer", }}
                  src={item?.headImage ?
                    item.headImage :
                    "https://t3.ftcdn.net/jpg/03/46/83/96/360_F_346839683_6nAPzbhpSkIpb8pmAwufkC7c5eD7wYws.jpg"}
                  //onClick={() => photoOnClick()} 
                  onClick={() => cambiaImmagineClick({ tipo: 'immaginePiccola', index: i, clicked: !immagineClick.clicked })}
                  title="Clicca per cambiare l'immagine"></img>
              </div>



              <div className="col-lg-3 ">
                <Controller
                  name={"title"}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      //className="mt-8 mb-16"
                      //error={!!errors.bannerName}
                      //required
                      //helperText={errors?.bannerName?.message}
                      value={form.bannerImageScroll[i].title}
                      onChange={(e) => changebannerImageScroll(i, { ...form.bannerImageScroll[i], title: e.target.value })}
                      label="Titolo"
                      //autoFocus={!isMobile}
                      id={"title" + i}
                      variant="outlined"
                      fullWidth
                      disabled={inSalvataggio}
                    />
                  )}
                />
              </div>

              <div className="col-lg-3 ">
                <Controller
                  name={"url" + i}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      //className="mt-8 mb-16"
                      //error={!!errors.bannerName}
                      //required
                      //helperText={errors?.bannerName?.message}
                      value={form.bannerImageScroll[i].url}
                      onChange={(e) => changebannerImageScroll(i, { ...form.bannerImageScroll[i], url: e.target.value })}
                      label="Apri link"
                      //autoFocus={!isMobile}
                      id={"url" + i}
                      variant="outlined"
                      fullWidth
                      disabled={inSalvataggio}
                    />
                  )}
                />
              </div>
              <div className="col-lg-3 ">
                <Controller
                  name={"buttonCaption" + 1}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      //className="mt-8 mb-16"
                      //error={!!errors.bannerName}
                      //required
                      //helperText={errors?.bannerName?.message}
                      value={form.bannerImageScroll[i].buttonCaption}
                      onChange={(e) => changebannerImageScroll(i, { ...form.bannerImageScroll[i], buttonCaption: e.target.value })}
                      label="Testo pulsante"
                      //autoFocus={!isMobile}
                      id={"buttonCaption" + i}
                      variant="outlined"
                      fullWidth
                      disabled={inSalvataggio}
                    />
                  )}
                />
              </div>

              <div className="col-lg-1" style={{ color: '#f72008', paddingTop: '6px', cursor: 'pointer' }} onClick={() => deletebannerImageScroll(item)}>
                <i class="fa fa-trash-o fa-2x" aria-hidden="true" style={{ color: '#f72008' }}></i>
              </div>
            </div>
            <Divider />
          </div>
        )

      }))
  }

  const getBannerList2 = () => {
    if (!form.bannerImageScroll || form.bannerImageScroll.length === 0) return null;
    return (
      form.bannerImageScroll?.map((item, i) => {
        return (
          <div style={{ backgroundColor: '#f3f3f3', paddingBottom: '5px', paddingBottom: '5px', marginBottom: '5px' }} >

            <div className="row">

              <div className="col-lg-2">
                <img id={"immagineGrande" + i}
                  style={{ height: 75, width: null, padding: 2, margin: 2, cursor: "pointer", }}
                  src={item.image ?
                    item.image :
                    "https://t3.ftcdn.net/jpg/03/46/83/96/360_F_346839683_6nAPzbhpSkIpb8pmAwufkC7c5eD7wYws.jpg"}
                  //onClick={() => photoOnClick()} 
                  onClick={() => cambiaImmagineClick({ tipo: 'immagineGrande', index: i, clicked: !immagineClick.clicked })}

                  title="Clicca per cambiare l'immagine"></img>
              </div>

              <div className="col-lg-3 ">
                <Controller
                  name={"title"}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      //className="mt-8 mb-16"
                      //error={!!errors.bannerName}
                      //required
                      //helperText={errors?.bannerName?.message}
                      value={form.bannerImageScroll[i].title}
                      onChange={(e) => changebannerImageScroll(i, { ...form.bannerImageScroll[i], title: e.target.value })}
                      label="Titolo"
                      //autoFocus={!isMobile}
                      id={"title" + i}
                      variant="outlined"
                      fullWidth
                      disabled={inSalvataggio}
                    />
                  )}
                />
              </div>

              <div className="col-lg-6 ">
                <Controller
                  name={"url" + i}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      //className="mt-8 mb-16"
                      //error={!!errors.bannerName}
                      //required
                      //helperText={errors?.bannerName?.message}
                      value={form.bannerImageScroll[i].url}
                      onChange={(e) => changebannerImageScroll(i, { ...form.bannerImageScroll[i], url: e.target.value })}
                      label="Apri link"
                      //autoFocus={!isMobile}
                      id={"url" + i}
                      variant="outlined"
                      fullWidth
                      disabled={inSalvataggio}
                    />
                  )}
                />
              </div>

              <div className="col-lg-1" style={{ color: '#f72008', paddingTop: '6px', cursor: 'pointer' }} onClick={() => deletebannerImageScroll(item)}>
                <i class="fa fa-trash-o fa-2x" aria-hidden="true" style={{ color: '#f72008' }}></i>
              </div>
            </div>
            <Divider />
          </div>
        )

      }))
  }
  const salvaBanners = () => {
    if (!isValid) {
      trigger();
      return;
    }

    setInSalvataggio(true);
    setBanners();
  }

  const setDefaultBanner = async (defaultTimeStamp, isDefault) => {
    if (inSalvataggio) return;

    setInSalvataggio(true);
    const newBanners = isDefault
      ? allBanners.map(_banner => _banner.timeStamp === defaultTimeStamp ? { ..._banner, defaultBanner: true } : { ..._banner, defaultBanner: false })
      : allBanners.map(_banner => _banner.timeStamp === defaultTimeStamp ? { ..._banner, defaultBanner: false } : { ..._banner });

    const modifiedBanner = allBanners.find(_banner => _banner.timeStamp === defaultTimeStamp);
    if (!modifiedBanner) {
      setInSalvataggio(false);
      return;
    }

    modifiedBanner.defaultBanner = isDefault;

    setNoRouteNavigate(true);

    //console.log(userData.user.user.username);
    setBanners(modifiedBanner, newBanners, true);

  }

  const navigateTO = (_url) => {
    const _pathLocation = window.location.pathname;
    if (_pathLocation === _url) return;

    history.push({
      pathname: _url, //'/personalizzaBanners/',
      state: { redirectUrl: _url /*'/personalizzaBanners/'*/ },
      destinaTionLink: _url // '/personalizzaBanners/'
    });
  }

  const newBanner = () => { navigateTO('/personalizzaBanners/') }

  return (
    <>


      <Fragment>


        <MetaTags>
          <title>DGA Planet Shirt SRL | personalizzaBanners</title>
          <meta
            name="description"
            content="powered by Pegaso Gest Team"
          />
        </MetaTags>

        <LayoutOne headerTop="invisible" footerTop="invisible">

          <div >
            <div >

              <div className="custom-row-2">
                <div className="col-lg-4 col-md-5" style={{ padding: '0px', overflowX: 'auto', maxHeight: '800px' }}>
                  <div className="contact-info-wrap" style={{ padding: '0px' }}>
                    <PersonalizeBannersSidebarContent allBanners={allBanners} setDefaultBanner={setDefaultBanner} tipoBanner={tipoBanner} newBanner={newBanner} currentBannerTimeStamp={form.timeStamp} />
                  </div>
                </div>
                <div className="col-lg-8 col-md-7 " style={{ paddingLeft: '10px', paddingRight: '10px' }}  >
                  <div className="">
                    <div className="row">
                      <div className="col-lg-10">
                        <h2>Configurazione Banner</h2>
                      </div>
                      <div className="col-lg-2">
                        {!inSalvataggio ?
                          <Button
                            className="whitespace-nowrap mx-4"
                            variant="contained"
                            color="primary"
                            onClick={salvaBanners}
                            disabled={!isValid || _.isEmpty(dirtyFields)}
                          >
                            Salva
                          </Button>
                          :
                          <ReactLoading type={"spinningBubbles"} color="#2E98F0" onClick={() => setInSalvataggio(false)} />
                        }
                      </div>
                    </div>
                    <form onSubmit={handleSubmit} disabled={inSalvataggio}>
                      <div className="row pb-5">

                        <div className="col-lg-10 pb-20">

                          <FormControl fullWidth>
                            <InputLabel id="selectTipoBanner">Tipo Banner</InputLabel>
                            <Controller
                              fullWidth
                              name="bannerType"
                              id="bannerType"
                              defaultValue={0}
                              control={control}
                              render={({ field }) => (
                                <Select labelId="level-label" {...field} disabled={inSalvataggio}>
                                  {tipoBanner.map((_tipoBanner) => <MenuItem value={_tipoBanner.id}>{_tipoBanner.description}</MenuItem>)}
                                </Select>
                              )}
                            />
                            <FormHelperText error={true}>{errors.level?.message}</FormHelperText>
                          </FormControl>

                        </div>



                        {!!(userData?.user?.user && form.bannerType && form.bannerType != '0') && <>

                          <div className="col-lg-10">
                            <Controller
                              name="bannerName"
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  className="mt-8 mb-16"
                                  error={!!errors.bannerName}
                                  required
                                  helperText={errors?.bannerName?.message}
                                  label="Nome Banner"
                                  //autoFocus={!isMobile}
                                  id="bannerName"
                                  variant="outlined"
                                  fullWidth
                                  disabled={inSalvataggio}
                                />
                              )}
                            />
                          </div>

                          <div className="col-lg-2" style={{ color: inSalvataggio ? 'gray' : 'blue', paddingTop: '6px', cursor: inSalvataggio ? null : 'pointer' }} onClick={() =>
                            cambiaImmagineClick({ tipo: 'immagineGrande', index: -1, clicked: !immagineClick.clicked })}
                          /*photoOnClick()}*/
                          >
                            <i class="fa fa-file-image-o fa-3x" aria-hidden="true" >  </i>
                          </div>




                          <input type="file" className="hidden" id="image-upload" name="img" accept="image/*" onChange={(e) => submitImage(e)}>
                          </input>


                        </>}
                      </div>
                    </form>

                    <Divider />
                    {(useMemo(() => getBannerList(), [form.bannerImageScroll, form.heroSliderData, inSalvataggio, form.bannerType]))}



                  </div>
                </div>
              </div>
              <HomeBanner userData = {userData}  bannerProps = {{...form}} forTestOnly = {true}/>
            </div>
          </div>

        </LayoutOne>
      </Fragment>
    </>
  );
};

PersonalizeBanners.propTypes = {
  userData: PropTypes.object,
};

const mapStateToProps = state => {
  return {
    userData: state.userData
  };
};
/*
const mapDispatchToProps = dispatch => {
  return {
    //saveUser: (user, addToast) => {dispatch(saveUser(user, addToast))}
  };
};*/

export default connect(mapStateToProps)(PersonalizeBanners);
